import { Environment } from "@axelar-network/axelarjs-sdk";

export const GAS_LIMIT_MULTIPLIER = 1.2;
export const DISPLAY_CHAIN_TYPE = Environment.MAINNET;
export const DEFAULT_EVM_CHAIN_ID = "1";
export const DEFAULT_COSMOS_CHAIN_ID = "osmosis-1";
export const MINT_TOKEN_DECIMALS = 18;
export const MINT_TOKEN_FRONTEND_PRECISION = 3;
export const MINT_POWER_FRONTEND_PRECISION = 3;
export const MARKETPLACE_PAGE_SIZE = 25;
export const DEFAULT_MAX_BASE_GAS_USED_BY_BRIDGE = 200000;
export const DEFAULT_MAX_GAS_USED_TO_BRIDGE_NFT = 150000;

interface Config {
  backendUrl?: string;
  aiAgentBackendUrl?: string;
  backendMarketplaceUrl?: string;
  marketplaceStorageBucket: string;
  databaseUrl?: string;
}

const config: Config = {
  backendUrl: "https://mygateway.io/api",
  aiAgentBackendUrl:
    "https://europe-west1-mintdao-app.cloudfunctions.net/aiAgentApp/api",
  // "http://localhost:5001/api",
  backendMarketplaceUrl:
    "https://europe-west1-mintdao-app.cloudfunctions.net/mintdao-backend-prod",
  marketplaceStorageBucket: "https://mintdao-nft-media-cache.b-cdn.net",
  databaseUrl:
    "https://mintdao-app-default-rtdb.europe-west1.firebasedatabase.app",
};

if (process.env.REACT_APP_ENVIRONMENT === "development") {
  config.backendUrl =
    process.env.REACT_APP_BACKEND_URL || "https://develop.app.mintdao.io/api";

  config.backendMarketplaceUrl =
    //"http://127.0.0.1:5001/mintdao-backend";
    "https://europe-west1-mintdao-app.cloudfunctions.net/mintdao-backend";

  config.marketplaceStorageBucket =
    "https://storage.googleapis.com/mintdao-nft-media-cache-develop";

  config.databaseUrl =
    process.env.REACT_APP_DATABASE_URL ||
    "https://mintdao-app-develop.europe-west1.firebasedatabase.app";
}

export const BACKEND_URL = config.backendUrl;
export const BACKEND_MARKETPLACE_URL = config.backendMarketplaceUrl;
// export const BACKEND_MARKETPLACE_URL = "http://localhost:5001/mintdao-backend";
export const MARKETPLACE_STORAGE_BUCKET_URL = config.marketplaceStorageBucket;
export const DATABASE_URL = config.databaseUrl;
export const OLD_GATEWAY_URL = "https://app.mygateway.io";
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
export const BACKEND_AI_AGENT_URL = config.aiAgentBackendUrl;
